var map = {
	"./button.raw.yml": 9413,
	"./empty.raw.yml": 1257,
	"./example.raw.yml": 3524,
	"./form.define.raw.yml": 788,
	"./form.raw.yml": 5859,
	"./functional-demo.raw.yml": 8166,
	"./jxmlview.nest.raw.yml": 3097,
	"./jxmlview.raw.yml": 1957,
	"./micro-frontend.raw.yml": 4,
	"./remote-demo.raw.yml": 2769
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3977;